<template>
    <Berriesforecastnotealertcategories>        
    </Berriesforecastnotealertcategories>
</template>
<script>

import Berriesforecastnotealertcategories from '@/components/configuration/Berriesforecastnotealertcategories.vue'

export default {    
    components: {
        Berriesforecastnotealertcategories: Berriesforecastnotealertcategories
    }
}
</script>